import { useQuery } from '@apollo/react-hooks';

import { UsersInfoQuery } from '../graphql/UsersInfoQuery.graphql';

type UsersInfoQueryProps = {
	userIds: string[] | null;
	isUpdatedMentionsInLivePagesEnabled: boolean;
};

export const useUsersInfoQuery = ({
	userIds,
	isUpdatedMentionsInLivePagesEnabled,
}: UsersInfoQueryProps) => {
	const { data: usersInfoData, error: usersInfoError } = useQuery(UsersInfoQuery, {
		variables: { accountIds: userIds },
		skip: !isUpdatedMentionsInLivePagesEnabled || userIds?.length === 0,
	});

	return {
		usersInfoData: usersInfoData?.confluenceUsers?.nodes || [],
		usersInfoError,
	};
};
